import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Logo from "../components/Logo";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Accesso negato");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center px-6">
      <form
        data-testid="admin-login-form"
        onSubmit={submit}
        className="w-full max-w-sm"
      >
        <div className="mb-12 flex justify-center">
          <Logo onClick={() => nav("/")} dataTestid="login-logo" />
        </div>
        <h1 className="font-display text-3xl mb-8 text-center">Accesso atelier</h1>
        <label className="block mb-4">
          <span className="label-eyebrow">Email</span>
          <input
            data-testid="admin-login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="tr-field"
          />
        </label>
        <label className="block mb-8">
          <span className="label-eyebrow">Password</span>
          <input
            data-testid="admin-login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="tr-field"
          />
        </label>
        <button data-testid="admin-login-submit" disabled={busy} className="tr-btn w-full justify-center">
          {busy ? "Accesso…" : "Entra"}
        </button>
      </form>
    </main>
  );
}
